import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import usePastTime from 'hooks/usePastTime';
import { getNodeMimeType } from 'utils';
import { isMaximumSelected } from 'router/subrouters/DataRoom/utils';

import './ListOfNodes.styles.scss';
import './ListOfNodes.styles.responsive.scss';

type ListOfNodesProps = {
  className?: string;
  nodes: DataRoomNode[];
};

const HEADERS = ['name', 'views', 'downloads', 'lastAccess'];

const ListOfNodes: React.FC<ListOfNodesProps> = (props) => {
  const { className, nodes } = props;

  const classes = classNames('list-of-nodes', className);

  const pastTime = usePastTime();

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <div className="list-of-nodes__header">
        {HEADERS.map((col) => (
          <p key={col}>{t(col)}</p>
        ))}
      </div>

      <div className="list-of-nodes__content">
        {nodes.map((node) => {
          const {
            _id,
            name,
            leadNumberOfViews,
            leadNumberOfDownloads,
            leadLastAccess,
            fileSecurity,
          } = node;

          return (
            <div key={_id}>
              <MymeTypeIcon
                mimeType={getNodeMimeType(node)}
                isLocked={isMaximumSelected(fileSecurity)}
              />
              <p className="name">{name}</p>
              <p>{leadNumberOfViews}</p>
              <p>{leadNumberOfDownloads}</p>
              <p>{leadLastAccess ? pastTime(leadLastAccess) : '-'}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListOfNodes;
